var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { MODAL_ANIMATION_DURATION } from '../../../../infra/dls/components/modal/modal';
import { TextM } from '../../../../infra/dls/components/typography';
import { useApiMutation, useApiQuery } from '../../../../infra/api';
import { showNotification } from '../../../../../app/common/helpers/notifications';
import { useSession } from '../../../../infra/session';
import { useBreakpoints } from '../../../../infra/dls/hooks/use-get-breakpoints';
import { InviteModal } from './invite-modal';
import { Button } from '../../../../infra/dls/components/button/button';
import { endpoints as shopEndpoints } from '../../../../shop/network';
import { endpoints } from '../../network';
import { t } from '../../../../infra/i18n';
var getSubtitle = function () { return _jsx(TextM, { color: "secondary", children: t('engage:invite.modal_subtitle') }); };
export var InviteModalContainer = function (_a) {
    var _b, _c;
    var onClose = _a.onClose;
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var session = useSession().data;
    var _d = useState([]), barbersPermissions = _d[0], setBarbersPermissions = _d[1];
    var shopId = (_c = (_b = (session === null || session === void 0 ? void 0 : session.view).viewer) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : '';
    var _e = useState(true), isVisible = _e[0], setIsVisible = _e[1];
    var barbers = useApiQuery({
        endpoint: shopEndpoints.barbersByShopQuery,
        payload: {
            shopId: shopId,
        },
    }).data;
    useEffect(function () {
        if (barbers) {
            setBarbersPermissions(barbers.sort(function (a, b) { return a.firstName.localeCompare(b.firstName); }));
        }
    }, [barbers]);
    var _f = useApiMutation({
        endpoint: endpoints.engagePermissionsMutation,
        options: {
            onSuccess: function () {
                showNotification({
                    title: t('engage:invite.success_title'),
                    message: t('engage:invite.success_message'),
                    autoDismiss: 8,
                });
                onClose();
            },
        },
    }), updateEngagePermissions = _f.mutate, isUpdatingPermissions = _f.isLoading;
    var handleChangeInvite = function (value, barberId) {
        setBarbersPermissions(function (prevBarbers) {
            if (barberId === 'all') {
                var allTrue = prevBarbers.every(function (barber) { var _a, _b; return (_b = (_a = barber.permissions) === null || _a === void 0 ? void 0 : _a.engage) === null || _b === void 0 ? void 0 : _b.view; });
                var allFalse = prevBarbers.every(function (barber) { var _a, _b; return !((_b = (_a = barber.permissions) === null || _a === void 0 ? void 0 : _a.engage) === null || _b === void 0 ? void 0 : _b.view); });
                var newValue_1 = value;
                if (allTrue) {
                    newValue_1 = false;
                }
                else if (allFalse) {
                    newValue_1 = true;
                }
                return prevBarbers.map(function (barber) { return (__assign(__assign({}, barber), { permissions: __assign(__assign({}, barber.permissions), { engage: {
                            view: newValue_1,
                        } }) })); });
            }
            return prevBarbers.map(function (barber) {
                return barber.id === barberId
                    ? __assign(__assign({}, barber), { permissions: __assign(__assign({}, barber.permissions), { engage: {
                                view: value,
                            } }) }) : barber;
            });
        });
    };
    var handleUpdatePermissions = function () {
        var payload = barbersPermissions.map(function (_a) {
            var _b;
            var id = _a.id, permissions = _a.permissions;
            return ({
                id: id,
                permissions: { view: (_b = permissions === null || permissions === void 0 ? void 0 : permissions.engage.view) !== null && _b !== void 0 ? _b : false },
            });
        });
        updateEngagePermissions({
            shopId: shopId,
            barbers: payload,
        });
    };
    var title = t('engage:invite.modal_title');
    var updatePermissionsButton = (_jsx(Button.Primary, { fullWidth: isMobileOrSmaller, "data-automation-id": "button-update-permissions", onClick: handleUpdatePermissions, loading: isUpdatingPermissions, children: t('engage:invite.update_permissions') }));
    var handleClose = function () {
        setIsVisible(false);
        setTimeout(function () {
            onClose();
        }, MODAL_ANIMATION_DURATION);
    };
    return (_jsx(InviteModal, { isMobileOrSmaller: isMobileOrSmaller, isOpen: isVisible, barbersPermissions: barbersPermissions, onChangeInvite: handleChangeInvite, onClose: handleClose, title: title, subtitle: getSubtitle(), updatePermissionsButton: updatePermissionsButton }));
};
